import { defineStore } from "pinia";
import {
  type StaleUserActionRequest,
  type StaleUserApplyResponse,
  type StaleUserResponse,
  type SuperAdminCountResponse,
} from "shared-core/types/user";
import { buildUserFullName } from "shared-core/utils/all-utils";
import type {
  StaleUsersAwareInterface,
  SuperAdminsAwareInterface,
} from "shared-ui/types/integration-users-store.ts";
import { useApi } from "../utils/api.ts";

export const useGoogleWorkspaceUsersStore = defineStore(
  "googleWorkspaceUsers",
  {
    state: () => ({
      staleUsers: [],
      staleUsersLastUpdated: null,
      superAdminCount: null,
    }),
    actions: {
      async fetchStaleUsers(): Promise<void> {
        const response = await useApi().get<StaleUserResponse>(
          "integrations/google-workspace/stale-users",
        );
        const responseData = await response.data;
        this.staleUsers = responseData.staleUsers.map((user) => ({
          ...user,
          fullName: buildUserFullName(user),
        }));
        this.staleUsersLastUpdated = responseData.lastUpdated;
      },

      async refreshStaleUsers(): Promise<void> {
        const response = await useApi().post<StaleUserResponse>(
          "integrations/google-workspace/stale-users/refresh",
        );
        const responseData = await response.data;
        this.staleUsers = responseData.staleUsers.map((user) => ({
          ...user,
          fullName: buildUserFullName(user),
        }));
        this.staleUsersLastUpdated = responseData.lastUpdated;
      },

      async applyStaleUserActions(
        actions: StaleUserActionRequest[],
      ): Promise<StaleUserApplyResponse> {
        const response = await useApi().post<StaleUserApplyResponse>(
          "integrations/google-workspace/stale-users/apply",
          {
            json: { actions },
          },
        );
        return response.data;
      },

      async fetchSuperAdminCount(): Promise<void> {
        const response = await useApi().get<SuperAdminCountResponse>(
          "integrations/google-workspace/super-admin-count",
        );
        this.superAdminCount = (await response.data).count;
      },
    } satisfies ThisType<SuperAdminsAwareInterface & StaleUsersAwareInterface>,
    getters: {},
  },
);
